import { createStore } from "vuex"
import dayjs from "dayjs"
import isBetween from "dayjs/plugin/isBetween"
import { sessionStore } from "@soenergy/frontend-library/src/services/StorageFactory"
import appointment from "./modules/appointment"
import homeDuringAppointment from "./modules/homeDuringAppointment"
import * as bookingDetails from "./modules/bookingDetails"
import { actions, getters, mutations } from "./untested/store"

dayjs.extend(isBetween)

export default createStore({
  modules: {
    appointment,
    homeDuringAppointment,
    bookingDetails,
  },
  state: {
    bookingData: [],
    customerId: sessionStore.getItem("customerId") || null,
    juniferAccountId: sessionStore.getItem("juniferAccountId") || null,
    authenticated: true,
    loading: false,
    showAuthError: false,
    junifer: false,
    accounts: null,
    meterRepairEligibility: null,
    meterInstallEligibility: null,
    meterReadingFrequency: null,
    submitStatus: null,
    submitError: null,
    isRegisterInterestFlow:
      sessionStore.getItem("isRegisterInterestFlow") || null,
    availabilitySlots: [],
    isAvailableSlots: false,
    questionnaire: {
      jobNote: {
        question: "Important to note re the job?",
        answer: null,
      },
      gasMeterLocation: {
        question: "Where is your gas meter located?",
        answer: null,
      },
      distanceBetweenMeters: {
        question:
          "What is the rough distance between your gas meter and your electricity meter?",
        answer: null,
      },
      meterAboveHeadHeight: {
        question:
          "One or more meters are above head height (the engineer will bring a ladder if so)",
        answer: false,
      },
      lessThanSixInchesAroundMeter: {
        question:
          "There is less than 15cm / 6 inches of space around one or more meters",
        answer: false,
      },
      parkingDetails: {
        question: "Where can the engineer park their van for the appointment?",
        answer: null,
      },
      petDetails: {
        question:
          "Do you have any dogs or other large pets? If so, please let our engineer know what to expect - even if they're friendly!",
        answer: null,
      },
    },
    confirmationList: [
      {
        text: "Your supply will be turned off for 30 minutes per meter during installation",
        value: false,
      },
      {
        text: "The engineer can access the main fuse to turn your supply off",
        value: false,
      },
    ],
  },
  mutations: {
    ...mutations,
    // Tested mutations below
  },
  actions: {
    ...actions,
    // Tested actions below
  },
  getters: {
    ...getters,
    // Tested getters below
  },
})
